import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=3a1d62da&"
import script from "./Callback.ts?vue&type=script&lang=ts&"
export * from "./Callback.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Callback.vue"
export default component.exports